// extracted by mini-css-extract-plugin
export default {"pageContent":"AdminRoutes_pageContent__d5BCa","pageContentBox":"AdminRoutes_pageContentBox__W0-BX"};